import { HeroSlider } from '../../components/home/HeroSlider';
import { CategoryTiles } from '../../components/home/CategoryTiles';
import { HomeProductSections } from '../../components/home/HomeProductSections';
import { Seo } from '../../components/seo';
import { SEO_PAGES } from '../../config/seo';
import { buildLocalBusinessJsonLd } from '../../seo/buildLocalBusinessJsonLd';
import styles from './HomePage.module.css';

export function HomePage() {
  const seo = SEO_PAGES.home;

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        jsonLd={buildLocalBusinessJsonLd()}
      />

      <HeroSlider />
      <CategoryTiles />
      <HomeProductSections />
    </div>
  );
}
